import { Checkbox as CheckboxMUI } from '@mui/material';
import { useEffect, useState } from 'react';
import { DataButtonPopover } from '../ButtonPopover';

type Props = {
  item: DataButtonPopover;
  onChecked: (checked: boolean) => void;
  isChecked: boolean;
};

export const Checkbox = ({ item, onChecked, isChecked = false }: Props) => {
  const [selected, setSelected] = useState(isChecked);

  useEffect(() => {
    setSelected(isChecked);
  }, [isChecked]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelected(event.target.checked);
    onChecked(event.target.checked);
  };

  return (
    <div className="specialties-city" key={item.id}>
      <CheckboxMUI color="secondary" checked={selected} onChange={handleChange} />
      <span>{item.name}</span>
    </div>
  );
};
